// document.addEventListener('DOMContentLoaded', function() {
  // console.log(4499)
  // 初始化时检查 Product Type
  toggleColorSelect(getSelectedProductType());
  // console.log(getSelectedCaseTypeOp())
  toggleProductTypeSelect(getSelectedCaseTypeOp());
  
  const taxElement = document.querySelector('.product__tax');
  if (taxElement) {
      taxElement.innerHTML = 'Ships out in 2-3 business days';
  }


  // // 监听 Product Type 变化
  document.addEventListener('change', function(event) {
    // if (event.target.name.includes("Product")) {
    //   // toggleColorSelect(event.target.value);
    //   setTimeout(() => {
    //     toggleColorSelect(event.target.value);
    //   }, 1500); // 延迟 2000 毫秒（2 秒）
    // }else if(event.target.name.includes("Color")){
    //   setTimeout(() => {
        
    //     showColorOption();
    //   }, 1500); // 延迟 2000 毫秒（2 秒）
    // }
  //  console.log(event.target.name)
    if (event.target.name.includes("Case")) {
      toggleProductTypeSelect(event.target.value);
      setTimeout(() => {
        toggleProductTypeSelect(event.target.value);
      }, 1000); // 延迟 2000 毫秒（2 秒）
    }

    if (event.target.name.includes("Device")){
      defaultCaseChecked();
      setTimeout(() => {
        defaultCaseChecked(event.target.value);
      }, 2000); // 延迟 2000 毫秒（2 秒）
    }
  });


  function toggleColorSelect(caseType) {
    // 查找所有 fieldset 元素
    const fieldsets = document.querySelectorAll('fieldset');
    
    // 遍历 fieldset 找到包含 "Select Color" 的
    let colorFieldset;
    fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend .font-body-bold');
        console.log(legend.textContent)
        if (legend && legend.textContent.includes('Color')) {
            colorFieldset = fieldset;
        }
    });
    // // 查找提示信息元素
    // const backCoverInfo = document.querySelector('.back-cover-info');
    if (colorFieldset){
      if (caseType === 'Back Cover') {
        
        // 隐藏 Color 选择器
        colorFieldset.style.display = 'none';
        // backCoverInfo.style.display = 'flex';
        
        // 获取所有颜色选择器
        var colorInputs = document.querySelectorAll('input[name*="Color"]');
        // 设置第一个颜色选择器为选中状态（如果存在）
        if (colorInputs.length > 0) {
            colorInputs[0].checked = true; // 选择第一个颜色
        }
        
      } else {
        // 显示 Color 选择器
        colorFieldset.style.display = 'flex';
        // backCoverInfo.style.display = 'none';
      }
    }
  }

  function defaultCaseChecked() {
    // console.log(22)
    const fieldsets = document.querySelectorAll('fieldset');
    let caseTypeFieldset;

    // Iterate through fieldsets to find the one containing "Case"
    fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend .font-body-bold');
        if (legend && legend.textContent.includes('Case')) {
            caseTypeFieldset = fieldset;
        }
    });

    // Check if the caseTypeFieldset exists
    if (caseTypeFieldset) {
        // Find input elements within the fieldset
        const caseInputs = caseTypeFieldset.querySelectorAll('input[name*="Case"]');
        for (let i = 0; i < caseInputs.length; i++) {
          // console.log(33)
            // Check if the input is not disabled
            if (!caseInputs[i].classList.contains('disabled')) {
                caseInputs[i].click(); // Click the first available input
                break; // Exit the loop after finding the first match
            }
        }
    }
  }

  function toggleProductTypeSelect(caseType) {
    console.log(caseType)
    // 查找所有 fieldset 元素
    const fieldsets = document.querySelectorAll('fieldset');
    
    // 遍历 fieldset 找到包含 "Product" 的
    let productTypeFieldset;
    fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend .font-body-bold');
        if (legend && legend.textContent.includes('Product')) {
            productTypeFieldset = fieldset;
        }
    });
    // 查找提示信息元素
    var ProductInputs = document.querySelectorAll('input[name*="Product"]');
if (caseType.toLowerCase().includes('essentique')) {
    if (ProductInputs.length > 0) {
        // 查找包含"unibody"值的input并点击（忽略大小写）
        for (var i = 0; i < ProductInputs.length; i++) {
            if (ProductInputs[i].value.toLowerCase().includes('unibody')) {
                ProductInputs[i].click();
                break; // 找到第一个匹配项后退出循环
            }
        }
    }
    // productTypeFieldset.style.display = 'none';
} else {
    // 显示 Color 选择器
    // productTypeFieldset.style.display = 'flex';
    if (ProductInputs.length > 0) {
        // 查找第一个不包含"unibody"值的input并点击（忽略大小写）
        for (var i = 0; i < ProductInputs.length; i++) {
            if (!ProductInputs[i].value.toLowerCase().includes('unibody')) {
                ProductInputs[i].click();
                break; // 找到第一个不包含unibody的选项后退出循环
            }
        }
    }
    // backCoverInfo.style.display = 'none';
}
  }

  // function showColorOption(){
  //   // 查找所有 fieldset 元素
  //   const fieldsets = document.querySelectorAll('fieldset');
    
  //   // 遍历 fieldset 找到包含 "Select Color" 的
  //   let colorFieldset;
  //   fieldsets.forEach(fieldset => {
  //       const legend = fieldset.querySelector('legend .font-body-bold');
  //       if (legend && legend.textContent.includes('Color')) {
  //           colorFieldset = fieldset;
  //       }
  //   });
  //   alert(colorFieldset.length)
  //   colorFieldset.style.display = 'flex';
  // }

  function getSelectedProductType() {
    return document.querySelector('input[name*="Product"]:checked').value;
  }

  function getSelectedCaseTypeOp() {
    return document.querySelector('input[name*="Case"]:checked').value;
  }


    //  // 通过类名定位 <select> 元素
    // const selectElement = document.querySelector('.product-form__input select');
  
    // if (selectElement) {
    //   new Choices(selectElement, {
    //     searchEnabled: false, // 禁用搜索框
    //     itemSelectText: '', // 移除选中提示
    //   });
    // } else {
    //   console.error('未找到符合条件的 <select> 元素');
    // }
// });